import { LoanBFFConfig } from 'Utils/httpClientLoanBff/loanBFFConfig';
import { AccountBff } from './AccountBff';
import { ConsumerEnablementBff } from './ConsumerEnablementBff';
import { ConsumerEnablementBffV1 } from './ConsumerEnablementBffV1';
import { ConsumerEnablementBffV3 } from './ConsumerEnablementBffV3';
import { EnrichmentBFF } from './EnrichmentBFF';

export const accountBff = new AccountBff();

export const consumerEnablementBff = new ConsumerEnablementBff();

export const consumerEnablementBffV2 = new ConsumerEnablementBff();
consumerEnablementBffV2.prefix = '/api/v2/';

export const consumerEnablementBffV1 = new ConsumerEnablementBffV1();
export const consumerEnablementBffV3 = new ConsumerEnablementBffV3();
export const loanApplicationBff = new LoanBFFConfig();

export const enrichmentBFF = new EnrichmentBFF();

export default {
  accountBff,
  consumerEnablementBff,
  consumerEnablementBffV2,
  consumerEnablementBffV3,
  enrichmentBFF,
  loanApplicationBff,
};
